import { Pipe, PipeTransform } from 'ng-metadata/core';

interface BASENUMBERS {
    Q: number
    T: number
    B: number
    M: number
    k: number
    '': number
}

/**
 * @ngdoc filter
 * @name mwUsNumberSystem
 * @module mw.components.dataFormatting
 *
 * @param {number} [input] - The number of people that have been reached
 * @returns {string|number} A formatted value for the content's reach
 *
 * @description
 * `usNumberSystem` is responsible for taking the people of people reached by some piece
 * of content and morphing it into a more readable format
 */
@Pipe({
    name: 'mwUsNumberSystem'
})
export class UsNumberSystemPipe implements PipeTransform {
    BaseNumbers: BASENUMBERS = {
        Q: 1000000000000000,
        T: 1000000000000,
        B: 1000000000,
        M: 1000000,
        k: 1000,
        '': 1
    }

    transform(input: number): string | number {
        input = input && !isNaN(input) ? Math.abs(input) : 0

        if (input === 0 || input > this.BaseNumbers.Q) {
            return input
        }

        for (let key of Object.keys(this.BaseNumbers)) {
            if (input >= this.BaseNumbers[key]) {
                return Math.round(input / this.BaseNumbers[key]) + '' + key;
            }
        }

        return input;
    }
}



// WEBPACK FOOTER //
// ./src/lib/components/data-formatting/us-number-system.pipe.ts